import { Injectable } from '@angular/core';

import { Action, select, Store } from '@ngrx/store';

import * as fromNotificationTriggers from './notification-triggers.reducer';
import * as NotificationTriggersSelectors from './notification-triggers.selectors';
import { getAllNotificationTriggers } from './notification-triggers.selectors';
import * as fromUsers from '@boma/supplier-portal/users';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { loadNotificationTriggers } from './notification-triggers.actions';
import { NotificationsApiService } from '../../../../../shared/services/src/lib/notifications/notifications-api.service';
import { INotificationTrigger } from '@boma/supplier-portal/shared/entities';

@Injectable()
export class NotificationTriggersFacade {
  loaded$ = this.notificationTriggersStore.pipe(
    select(NotificationTriggersSelectors.getNotificationTriggersLoaded)
  );
  allNotificationTriggers$ = this.notificationTriggersStore.pipe(
    select(NotificationTriggersSelectors.getAllNotificationTriggers)
  );
  selectedNotificationTriggers$ = this.notificationTriggersStore.pipe(
    select(NotificationTriggersSelectors.getSelected)
  );

  entityNotificationTriggers$ = combineLatest([
    this.notificationTriggersStore.select(getAllNotificationTriggers).pipe(
      map((triggers) =>
        // Only entity notification triggers
        triggers.filter((trigger) => !trigger.location && !trigger.targetId)
      )
    ),
    this.notificationsService.notificationTypes$,
  ]).pipe(
    map(([triggers, notificationTypes]) => {
      return notificationTypes.reduce((previousValue, currentValue) => {
        previousValue[currentValue.id] = triggers.filter(
          (trigger) => currentValue.id === trigger.notificationType.id
        )[0];
        return previousValue;
      }, {} as { [notificationType: number]: INotificationTrigger });
    })
  );

  loadNotificationTriggers() {
    this.dispatch(
      loadNotificationTriggers({
        notificationTypes: [],
        locationIds: [],
        targetIds: [],
      })
    );
  }

  constructor(
    private notificationTriggersStore: Store<
      fromNotificationTriggers.NotificationTriggersPartialState
    >,
    private store: Store,
    private userStore: Store<fromUsers.UsersPartialState>,
    private notificationsService: NotificationsApiService
  ) {}

  dispatch(action: Action) {
    this.notificationTriggersStore.dispatch(action);
  }
}
